import React, { useState, useEffect } from "react";
import Cartlist from "../cart/Cartlist";
import Cartstatus from "../cart/Cartstatus";
import { IMAGEURL } from "../../config/config";

function Cartitems(props) {
  const cartSubtotal = props.cartData?.subtotal || 0;
  const [, setUpdateTrigger] = useState(0);

  // Force re-render when cartSubtotal changes
  useEffect(() => {
    setUpdateTrigger(prev => prev + 1);
  }, [cartSubtotal]);

  // Filter out free gift items from cart items (they are already in free gifts list)
  const paidCartItems = (props.cartItems || []).filter(item => item.is_free_gift !== true);
  const freeGiftCartItems = (props.cartItems || []).filter(
    item => item.is_free_gift === true
  );

  useEffect(() => {
    // If no paid items AND no free items => clear cart
    if (paidCartItems.length === 0) {
      props.onClearCart && props.onClearCart();
    }
  }, [paidCartItems.length]);

  return (
    <div className="cartmain_l customscroll">
      <div className="cartlist">
        {/* Render Free Gift Products - those unlocked from campaigns */}
        {paidCartItems.length > 0 && props.freeGiftProducts?.map((gift, index) => {
          const orderAmount = parseFloat(gift.order_amount?.$numberDecimal || gift.order_amount || 0);
          const isUnlocked = cartSubtotal >= orderAmount;

          return (
            <div key={`gift-${index}`} className={`cartlistitem ${isUnlocked ? 'freegift' : 'unlocks'}`}>
              <figure className="">
                <img src={IMAGEURL + gift.product.image} alt={gift.name} />
              </figure>
              <div className="mobtwo">
                <p className="itemcart">{gift.name}</p>
                <div className="freegiftprice">{gift.quantity} <span>{gift.unit}</span></div>
                <div className="pricetext">
                  {isUnlocked ? 'Free Gift Unlocked' : `Unlock @ $${orderAmount} Subtotal`}
                </div>
              </div>
            </div>
          );
        })}

        {/* Render only PAID cart items (exclude free gift items already persisted in cart) */}
        {paidCartItems.length > 0 && paidCartItems.map((item) => (
          <Cartlist
            key={item._id}
            updateItem={props.updateItem}
            deleteItem={props.deleteItem}
            cartLoad={props.cartLoad}
            onFreeGift={props.onFreeGift}
            cartSubtotal={cartSubtotal}
            {...item}
          />
        ))}
      </div>

      <Cartstatus />

    </div>
  );
}

export default Cartitems;
